export const modalContainer = ({ isMobile }) => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  fontStyle: "normal",
  fontWeight: 400,
  textTransform: "uppercase",
});

export const modalVideoContainer = ({ isMobile }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",

  "&> video": {
    minWidth: isMobile ? "100%" : "auto",
    height: isMobile ? "320px" : "100%",
    objectFit: "cover",
  },

  ":hover > #modal-video-play-button": {
    display: "block",
  },
});

export const videoPlayButton = {
  position: "absolute",
  bottom: "0",
  right: "7px",
  transform: "translate(-5%, -5%)",
  cursor: "pointer",
};

export const videoPauseButton = {
  position: "absolute",
  bottom: "0",
  right: "7px",
  transform: "translate(-5%, -5%)",
  cursor: "pointer",
  display: "none",
};

export const modalTitleContainer = {
  display: "flex",
  flexDirection: "column",
};

export const modalHeader = {
  fontSize: "20px",
  lineHeight: "20px",
  letterSpacing: "0.05em",
};

export const modalHeaderLabel = {
  paddingBottom: "20px",
  borderBottom: "solid 4px",
  borderColor: "grey9",
  marginBottom: "20px",
  fontSize: "50px",
  lineHeight: "50px",
  letterSpacing: "0.01em",
};

export const modalContentContainer = {
  display: "flex",
  flexDirection: "column",
  padding: "40px",
  zIndex: 100,
};

export const modalContent = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  fontWeight: 200,
  fontSize: "20px",
  lineHeight: "24px",
  letterSpacing: "0.025em",
  textTransform: "capitalize",
  marginBottom: "20px",
  paddingBottom: "20px",
  borderBottom: "solid 4px",
  borderColor: "grey9",
};

export const modalTitle = {
  textTransform: "uppercase",
  paddingBottom: "20px",
  borderBottom: "solid 4px",
  borderColor: "grey9",
  marginBottom: "20px",
  lineHeight: "30px",
};

export const modalContentText = {
  fontWeight: "400",
};
